module.exports = __webpack_public_path__ + "img/03.6b4b3770.jpg";